<div class="search-input-form">
  <i class="cc-icon cc-icon-search"></i>
  <input
    class="input-text-base search-input"
    type="text"
    placeholder="Search users"
    name="searchText"
    [(ngModel)]="searchTerm"
    (ngModelChange)="emitValue($event)"
  />
  <div class="clear-search">
    <button *ngIf="searchTerm" (click)="clearSearch()">
      <i class="cc-icon cc-icon-close"></i>
    </button>
  </div>
</div>
